import { render, staticRenderFns } from "./InvestigationCard.vue?vue&type=template&id=3d2f0a88&scoped=true&"
import script from "./InvestigationCard.vue?vue&type=script&lang=ts&"
export * from "./InvestigationCard.vue?vue&type=script&lang=ts&"
import style0 from "./InvestigationCard.vue?vue&type=style&index=0&id=3d2f0a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f0a88",
  null
  
)

export default component.exports